


























































































import { Component, Vue, Prop, PropSync, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
// interfaces
import { OrganizationVm } from "@/interfaces/OrganizationVm";
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { TrainingEventCreateResultVm } from "@/interfaces/TrainingEventCreateResultVm";
import rest from "@/rest";

const globals = namespace("globals");

@Component
export default class TrainingEventCreateDialog extends Vue {
  @PropSync("showDialog") syncedShowDialog!: boolean;

  @globals.Getter selectedOrg!: OrganizationVm;

  valid = true;
  saving = false;
  errorText = "";

  title = "";
  description = "";
  isPublic = false;
  registrationDeadlineDays: string | null = "";
  cancellationDeadlineDays: string | null = "";
  waitlistEnabled = true;

  readonly titleRules = [
    (v: string) => !!(v && v.trim()) || "Bitte einen Titel eingeben.",
    (v: string) => (v || "").length <= 200 || "Maximal 200 Zeichen."
  ];

  // Optional whole number between 0 and 365
  readonly daysRules = [
    (v: string | null) => v === null || v === "" || (/^\d+$/.test(String(v)) && Number(v) <= 365) || "Ganze Zahl von 0 bis 365."
  ];

  @Watch("syncedShowDialog")
  onShowDialogChanged(show: boolean): void {
    if (show) this.reset();
  }

  reset(): void {
    this.title = "";
    this.description = "";
    this.isPublic = false;
    this.registrationDeadlineDays = "";
    this.cancellationDeadlineDays = "";
    this.waitlistEnabled = true;
    this.errorText = "";
    this.saving = false;
    this.$nextTick(() => (this.$refs.form as any)?.resetValidation());
  }

  close(): void {
    this.syncedShowDialog = false;
  }

  toDays(value: string | null): number | null {
    return value === null || value === "" ? null : Number(value);
  }

  async save(): Promise<void> {
    if (!(this.$refs.form as any).validate()) return;

    this.saving = true;
    this.errorText = "";
    try {
      // Empty values are sent as empty strings = not set
      const params: ParamDictionary = { dictionary: {} };
      params.dictionary!["OrgId"] = this.selectedOrg.id.toString();
      params.dictionary!["Title"] = this.title.trim();
      params.dictionary!["Description"] = this.description.trim();
      params.dictionary!["IsPublic"] = this.isPublic.toString();
      params.dictionary!["RegistrationDeadlineDays"] = this.registrationDeadlineDays ?? "";
      params.dictionary!["CancellationDeadlineDays"] = this.cancellationDeadlineDays ?? "";
      params.dictionary!["WaitlistEnabled"] = this.waitlistEnabled.toString();

      // On errors the rest wrapper shows the message and returns undefined: keep the dialog open then
      const result: TrainingEventCreateResultVm | undefined = await rest.url("trainingLead/createEvent").post(params);
      if (!result) return;

      this.syncedShowDialog = false;
      this.$emit("created", result.id);
    } catch (error) {
      this.errorText = "Die Veranstaltung konnte nicht angelegt werden. Bitte versuchen Sie es erneut.";
    } finally {
      this.saving = false;
    }
  }
}
